import { useLocation } from 'react-router-dom';

export const useModeID = () => {
  const location = useLocation();
  const { state } = location;
  const { screenMode = null, newsId = null } = state || {};

  return { screenMode, newsId };
};
